import { CountryCode } from "@app/models/CountryCode";
import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CountryCallingCodeApi extends HOAApiBase {

    constructor() {
        super('CountryCallingCodeApi')
    }

    public getAllCountries(anonymous: boolean): Observable<{ data: CountryCode[] }> {
        if (!anonymous) {
            return this.http.get<{ data: CountryCode[] }>(this.createUrl("hoa-gateway", "/country-calling-codes/country-calling-codes"));
        } else {
            return this.http.get<{ data: CountryCode[] }>(this.createUrl("HOAPass", "/country-calling-codes/country-calling-codes"));
        }
    }
}

